import {
  GET_CONTRACT_LIST,
  GET_CONTRACT_LIST_SUCCESS,
  GET_CONTRACT_LIST_FAILURE,
  GET_CONTRACT_STATUS_LIST,
  GET_CONTRACT_STATUS_LIST_SUCCESS,
  GET_CONTRACT_STATUS_LIST_FAILURE,
  GET_SINGLE_CONTRACT_ITEM,
  GET_SINGLE_CONTRACT_ITEM_SUCCESS,
  GET_SINGLE_CONTRACT_ITEM_FAILURE,
  UPDATE_CONTRACT_ITEM,
  UPDATE_CONTRACT_ITEM_SUCCESS,
  UPDATE_CONTRACT_ITEM_FAILURE,
  DELETE_CONTRACT_ITEMS,
  DELETE_CONTRACT_ITEMS_SUCCESS,
  DELETE_CONTRACT_ITEMS_FAILURE,
  SINGLE_CUSTOMER_SEARCH_CONTRACTS,
  SINGLE_CUSTOMER_SEARCH_CONTRACTS_SUCCESS,
  SINGLE_CUSTOMER_SEARCH_CONTRACTS_FAILURE,
  GET_CONTRACT_ITEMS_LIST,
  GET_CONTRACT_ITEMS_LIST_SUCCESS,
  GET_CONTRACT_ITEMS_LIST_FAILURE,
  GET_CONTRACT_ITEMS_STATUS_LIST,
  GET_CONTRACT_ITEMS_STATUS_LIST_SUCCESS,
  GET_CONTRACT_ITEMS_STATUS_LIST_FAILURE,
  GET_CONTRACT_UNIT_FREQUENCY_LIST,
  GET_CONTRACT_UNIT_FREQUENCY_LIST_SUCCESS,
  GET_CONTRACT_UNIT_FREQUENCY_LIST_FAILURE,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUCCESS,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_FAILURE,
  CREATE_CONTRACT_WITH_ITEMS_FAILURE,
  CREATE_CONTRACT_WITH_ITEMS_SUCCESS,
  CREATE_CONTRACT_WITH_ITEMS,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_SUCCESS,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_FAILURE,
  UPDATE_CONTRACT_WITH_ITEMS,
  UPDATE_CONTRACT_WITH_ITEMS_SUCCESS,
  UPDATE_CONTRACT_WITH_ITEMS_FAILURE,
  PREVIEW_CONTRACT_UPDATE,
  PREVIEW_CONTRACT_UPDATE_SUCCESS,
  PREVIEW_CONTRACT_UPDATE_FAILURE,
  PREVIEW_CONTRACT_CREATE,
  PREVIEW_CONTRACT_CREATE_SUCCESS,
  PREVIEW_CONTRACT_CREATE_FAILURE,
  GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST,
  GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_SUCCESS,
  GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_FAILURE,
  DELETE_SINGLE_CONTRACT_ITEM,
  DELETE_SINGLE_CONTRACT_ITEM_SUCCESS,
  DELETE_SINGLE_CONTRACT_ITEM_FAILURE,
  GET_CONTRACT_ITEMS_ACTIVE_LIST,
  GET_CONTRACT_ITEMS_ACTIVE_LIST_SUCCESS,
  GET_CONTRACT_ITEMS_ACTIVE_LIST_FAILURE,
  GET_CONTRACT_ITEMS_CANCELLED_LIST,
  GET_CONTRACT_ITEMS_CANCELLED_LIST_SUCCESS,
  GET_CONTRACT_ITEMS_CANCELLED_LIST_FAILURE,
  GET_CONTRACT_ITEM_USAGE_SEARCH_LIST,
  GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_SUCCESS,
  GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_FAILURE,
  GET_CONTRACT_ITEM_USAGE_LIST,
  GET_CONTRACT_ITEM_USAGE_LIST_SUCCESS,
  GET_CONTRACT_ITEM_USAGE_LIST_FAILURE,
  GET_CONTRACT_ITEM_USAGE_SEARCH,
  GET_CONTRACT_ITEM_USAGE_SEARCH_SUCCESS,
  GET_CONTRACT_ITEM_USAGE_SEARCH_FAILURE,
  SEARCH_CONTRACT_PDF,
  SEARCH_CONTRACT_PDF_SUCCESS,
  SEARCH_CONTRACT_PDF_FAILURE,
  DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE,
  DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_SUCCESS,
  DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_FAILURE,
  GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF,
  GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_SUCCESS,
  GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_FAILURE,
  GENERATE_CONTRACT_ITEM_USAGE,
  GENERATE_CONTRACT_ITEM_USAGE_SUCCESS,
  GENERATE_CONTRACT_ITEM_USAGE_FAILURE,
  GET_CONTRACT_ITEM_USAGE_PDF,
  GET_CONTRACT_ITEM_USAGE_PDF_SUCCESS,
  GET_CONTRACT_ITEM_USAGE_PDF_FAILURE,
  REGENERATE_CONTRACT_ITEM_USAGE_PDF,
  REGENERATE_CONTRACT_ITEM_USAGE_PDF_SUCCESS,
  REGENERATE_CONTRACT_ITEM_USAGE_PDF_FAILURE,
  GET_CONTRACT_ITEM_CREDIT_LIST,
  GET_CONTRACT_ITEM_CREDIT_LIST_SUCCESS,
  GET_CONTRACT_ITEM_CREDIT_LIST_FAILURE,
  CREATE_CONTRACT_ITEM_CREDIT,
  CREATE_CONTRACT_ITEM_CREDIT_SUCCESS,
  CREATE_CONTRACT_ITEM_CREDIT_FAILURE,
  UPDATE_CONTRACT_ITEM_CREDIT,
  UPDATE_CONTRACT_ITEM_CREDIT_SUCCESS,
  UPDATE_CONTRACT_ITEM_CREDIT_FAILURE,
  DELETE_CONTRACT_ITEM_CREDIT,
  DELETE_CONTRACT_ITEM_CREDIT_SUCCESS,
  DELETE_CONTRACT_ITEM_CREDIT_FAILURE,
  GET_CONTRACT_ITEM_PORTFOLIO,
  GET_CONTRACT_ITEM_PORTFOLIO_SUCCESS,
  GET_CONTRACT_ITEM_PORTFOLIO_FAILURE,
  GET_CONTRACT_ITEM_DEBIT_LIST,
  GET_CONTRACT_ITEM_DEBIT_LIST_SUCCESS,
  GET_CONTRACT_ITEM_DEBIT_LIST_FAILURE,
  GET_JOB_LIST_BY_CONTRACT_ITEM,
  GET_JOB_LIST_BY_CONTRACT_ITEM_SUCCESS,
  GET_JOB_LIST_BY_CONTRACT_ITEM_FAILURE,
} from "./actionType";

// Initial State
const initialState = {
  contractList: [],
  contractListLoading: false,
  contractStatusList: [],
  singleContractItem: [],
  contractDeleteSuccess: {},
  contractItemUpdateSuccess: [],
  singleCustomerSearchContracts: [],
  contractItemsList: [],
  contractItemListLoading: false,
  contractItemsStatusList: [],
  contractUnitFrequencyList: [],
  singleCustomerContractItemsList: [],
  CreateContractWithItemsSuccess: [],
  CreateContractWithItemsSuccessLoading: false,
  singleCustomerContractItemsListSummary: [],
  updateContractWithItemsSuccess: [],
  updateContractWithItemsSuccessLoading: false,
  previewContractUpdate: [],
  previewContractUpdateLoading: false,
  previewContractCreate: [],
  previewContractCreateLoading: false,
  contractItemRenewalFrequencyList: [],
  singleCustomerSearchContractsLoading: false,
  singleCustomerContractItemsListLoading: false,
  deleteSingleContractItemSuccess: [],
  deleteSingleContractItemLoading: false,
  contractItemsActiveList: [],
  contractItemsCancelledList: [],
  contractItemUsageSearchList: [],
  contractItemUsageSearchListLoading: false,
  contractItemUsageList: [],
  contractItemUsageListLoading: false,
  contractItemUsageSearch: [],
  contractItemUsageSearchLoading: false,
  searchContractPdfData: [],
  searchContractPdfLoading: false,
  deleteAllPreviousContractItemUsageSuccess: [],
  deleteAllPreviousContractItemUsageLoading: false,
  contractItemUsageLiveBalancePdf: [],
  contractItemUsageLiveBalancePdfLoading: false,
  generateContractItemUsageSuccess: [],
  generateContractItemUsageLoading: false,
  contractItemUsagePdf: [],
  contractItemUsagePdfLoading: false,
  regenerateContractItemUsagePdfSuccess: [],
  regenerateContractItemUsagePdfLoading: false,
  contractItemCreditList: [],
  contractItemCreditListLoading: false,
  createContractItemCreditSuccess: [],
  createContractItemCreditLoading: false,
  updateContractItemCreditSuccess: [],
  updateContractItemCreditLoading: false,
  deleteContractItemCreditSuccess: [],
  deleteContractItemCreditLoading: false,
  contractItemPortfolio: [],
  contractItemPortfolioLoading: false,
  contractItemDebitList: [],
  contractItemDebitListLoading: false,
  jobListByContractItem: [],
  jobListByContractItemLoading: false,

};

// Reducer

const Contract = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTRACT_LIST:
      return {
        ...state,
        contractListLoading: true,
      };
    case GET_CONTRACT_LIST_SUCCESS:
      return {
        ...state,
        contractList: action.payload,
        contractListLoading: false,
      };
    case GET_CONTRACT_LIST_FAILURE:
      return {
        ...state,
        contractListLoading: false,
      };

    case GET_CONTRACT_STATUS_LIST:
      return {
        ...state,
      };
    case GET_CONTRACT_STATUS_LIST_SUCCESS:
      return {
        ...state,
        contractStatusList: action.payload,
      };
    case GET_CONTRACT_STATUS_LIST_FAILURE:
      return {
        ...state,
      };
    case GET_SINGLE_CONTRACT_ITEM:
      return {
        ...state,
      };
    case GET_SINGLE_CONTRACT_ITEM_SUCCESS:
      return {
        ...state,
        singleContractItem: action.payload,
      };
    case GET_SINGLE_CONTRACT_ITEM_FAILURE:
      return {
        ...state,
      };
    case UPDATE_CONTRACT_ITEM:
      return {
        ...state,
      };
    case UPDATE_CONTRACT_ITEM_SUCCESS:
      return {
        ...state,
        contractItemUpdateSuccess: action.payload,
      };
    case UPDATE_CONTRACT_ITEM_FAILURE:
      return {
        ...state,
      };
    case DELETE_CONTRACT_ITEMS:
      return {
        ...state,
      };
    case DELETE_CONTRACT_ITEMS_SUCCESS:
      return {
        ...state,
        contractDeleteSuccess: action.payload,
      };
    case DELETE_CONTRACT_ITEMS_FAILURE:
      return {
        ...state,
      };
    case SINGLE_CUSTOMER_SEARCH_CONTRACTS:
      return {
        ...state,
        singleCustomerSearchContractsLoading: true,
      };
    case SINGLE_CUSTOMER_SEARCH_CONTRACTS_SUCCESS:
      return {
        ...state,
        singleCustomerSearchContracts: action.payload,
        singleCustomerSearchContractsLoading: false,
      };
    case SINGLE_CUSTOMER_SEARCH_CONTRACTS_FAILURE:
      return {
        ...state,
        singleCustomerSearchContractsLoading: false,
      };
    case GET_CONTRACT_ITEMS_LIST:
      return {
        ...state,
        contractItemListLoading: true,
      };
    case GET_CONTRACT_ITEMS_LIST_SUCCESS:
      return {
        ...state,
        contractItemsList: action.payload,
        contractItemListLoading: false,
      };
    case GET_CONTRACT_ITEMS_LIST_FAILURE:
      return {
        ...state,
        contractItemListLoading: false,
      };
    case GET_CONTRACT_ITEMS_STATUS_LIST:
      return {
        ...state,
      };
    case GET_CONTRACT_ITEMS_STATUS_LIST_SUCCESS:
      return {
        ...state,
        contractItemsStatusList: action.payload,
      };
    case GET_CONTRACT_ITEMS_STATUS_LIST_FAILURE:
      return {
        ...state,
      };
    case GET_CONTRACT_UNIT_FREQUENCY_LIST:
      return {
        ...state,
      };
    case GET_CONTRACT_UNIT_FREQUENCY_LIST_SUCCESS:
      return {
        ...state,
        contractUnitFrequencyList: action.payload,
      };

    case GET_CONTRACT_UNIT_FREQUENCY_LIST_FAILURE:
      return {
        ...state,
      };
    case GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST:
      return {
        ...state,
        singleCustomerContractItemsListLoading: true,
      };
    case GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUCCESS:
      return {
        ...state,
        singleCustomerContractItemsList: action.payload,
        singleCustomerContractItemsListLoading: false,
      };
    case GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_FAILURE:
      return {
        ...state,
        singleCustomerContractItemsListLoading: false,
      };
    case CREATE_CONTRACT_WITH_ITEMS:
      return {
        ...state,
        CreateContractWithItemsSuccessLoading: true,
      };
    case CREATE_CONTRACT_WITH_ITEMS_SUCCESS:
      return {
        ...state,
        CreateContractWithItemsSuccess: action.payload,
        CreateContractWithItemsSuccessLoading: false,
      };
    case CREATE_CONTRACT_WITH_ITEMS_FAILURE:
      return {
        ...state,
        CreateContractWithItemsSuccessLoading: false,
      };
    case GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY:
      return {
        ...state,
      };

    case GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_SUCCESS:
      return {
        ...state,
        singleCustomerContractItemsListSummary: action.payload,
      };

    case GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_FAILURE:
      return {
        ...state,
      };
    case UPDATE_CONTRACT_WITH_ITEMS:
      return {
        ...state,
        updateContractWithItemsSuccessLoading: true,
      };
    case UPDATE_CONTRACT_WITH_ITEMS_SUCCESS:
      return {
        ...state,
        updateContractWithItemsSuccess: action.payload,
        updateContractWithItemsSuccessLoading: false,
      };
    case UPDATE_CONTRACT_WITH_ITEMS_FAILURE:
      return {
        ...state,
        updateContractWithItemsSuccessLoading: false,
      };
    case PREVIEW_CONTRACT_UPDATE:
      return {
        ...state,
        previewContractUpdateLoading: true,
      };
    case PREVIEW_CONTRACT_UPDATE_SUCCESS:
      return {
        ...state,
        previewContractUpdate: action.payload,
        previewContractUpdateLoading: false,
      };
    case PREVIEW_CONTRACT_UPDATE_FAILURE:
      return {
        ...state,
        previewContractUpdateLoading: false,
      };
    case PREVIEW_CONTRACT_CREATE:
      return {
        ...state,
        previewContractCreateLoading: true,
      };
    case PREVIEW_CONTRACT_CREATE_SUCCESS:
      return {
        ...state,
        previewContractCreate: action.payload,
        previewContractCreateLoading: false,
      };
    case PREVIEW_CONTRACT_CREATE_FAILURE:
      return {
        ...state,
        previewContractCreateLoading: false,
      };
    case GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST:
      return {
        ...state,
      };
    case GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_SUCCESS:
      return {
        ...state,
        contractItemRenewalFrequencyList: action.payload,
      };
    case GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_FAILURE:
      return {
        ...state,
      };
    case DELETE_SINGLE_CONTRACT_ITEM:
      return {
        ...state,
        deleteSingleContractItemLoading: true,
      };
    case DELETE_SINGLE_CONTRACT_ITEM_SUCCESS:
      return {
        ...state,
        deleteSingleContractItemSuccess: action.payload,
      };
    case DELETE_SINGLE_CONTRACT_ITEM_FAILURE:
      return {
        ...state,
        deleteSingleContractItemSuccess: action.payload,
        deleteSingleContractItemLoading: false,
      };
    case GET_CONTRACT_ITEMS_ACTIVE_LIST:
      return { ...state };
    case GET_CONTRACT_ITEMS_ACTIVE_LIST_SUCCESS:
      return { ...state, contractItemsActiveList: action.payload };
    case GET_CONTRACT_ITEMS_ACTIVE_LIST_FAILURE:
      return { ...state };
    case GET_CONTRACT_ITEMS_CANCELLED_LIST:
      return { ...state };
    case GET_CONTRACT_ITEMS_CANCELLED_LIST_SUCCESS:
      return { ...state, contractItemsCancelledList: action.payload };
    case GET_CONTRACT_ITEMS_CANCELLED_LIST_FAILURE:
      return { ...state };
    case GET_CONTRACT_ITEM_USAGE_SEARCH_LIST:
      return { ...state, contractItemUsageSearchListLoading: true };
    case GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_SUCCESS:
      return {
        ...state,
        contractItemUsageSearchList: action.payload,
        contractItemUsageSearchListLoading: false,
      };
    case GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_FAILURE:
      return { ...state, contractItemUsageSearchListLoading: false };

    case GET_CONTRACT_ITEM_USAGE_LIST:
      return { ...state, contractItemUsageListLoading: true };
    case GET_CONTRACT_ITEM_USAGE_LIST_SUCCESS:
      return {
        ...state,
        contractItemUsageList: action.payload,
        contractItemUsageListLoading: false,
      };
    case GET_CONTRACT_ITEM_USAGE_LIST_FAILURE:
      return { ...state, contractItemUsageListLoading: false };

    case GET_CONTRACT_ITEM_USAGE_SEARCH:
      return { ...state, contractItemUsageSearchLoading: true };
    case GET_CONTRACT_ITEM_USAGE_SEARCH_SUCCESS:
      return {
        ...state,
        contractItemUsageSearch: action.payload,
        contractItemUsageSearchLoading: false,
      };
    case GET_CONTRACT_ITEM_USAGE_SEARCH_FAILURE:
      return { ...state, contractItemUsageSearchLoading: false };

    case SEARCH_CONTRACT_PDF:
      return { ...state, searchContractPdfLoading: true };
    case SEARCH_CONTRACT_PDF_SUCCESS:
      return {
        ...state,
        searchContractPdfData: action.payload,
        searchContractPdfLoading: false,
      };
    case SEARCH_CONTRACT_PDF_FAILURE:
      return { ...state, searchContractPdfLoading: false };
    case DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE:
      return { ...state, deleteAllPreviousContractItemUsageLoading: true };
    case DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_SUCCESS:
      return {
        ...state,
        deleteAllPreviousContractItemUsageSuccess: action.payload,
        deleteAllPreviousContractItemUsageLoading: false,
      };
    case DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_FAILURE:
      return { ...state, deleteAllPreviousContractItemUsageLoading: false };
    case GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF:
      return { ...state, contractItemUsageLiveBalancePdfLoading: true };
    case GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_SUCCESS:
      return {
        ...state,
        contractItemUsageLiveBalancePdf: action.payload,
        contractItemUsageLiveBalancePdfLoading: false,
      };
    case GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_FAILURE:
      return { ...state, contractItemUsageLiveBalancePdfLoading: false };

    case GENERATE_CONTRACT_ITEM_USAGE:
      return { ...state, generateContractItemUsageLoading: true };
    case GENERATE_CONTRACT_ITEM_USAGE_SUCCESS:
      return {
        ...state,
        generateContractItemUsageSuccess: action.payload,
        generateContractItemUsageLoading: false,
      };
    case GENERATE_CONTRACT_ITEM_USAGE_FAILURE:
      return { ...state, generateContractItemUsageLoading: false };

    case GET_CONTRACT_ITEM_USAGE_PDF:
      return { ...state, contractItemUsagePdfLoading: true };
    case GET_CONTRACT_ITEM_USAGE_PDF_SUCCESS:
      return {
        ...state,
        contractItemUsagePdf: action.payload,
        contractItemUsagePdfLoading: false,
      };
    case GET_CONTRACT_ITEM_USAGE_PDF_FAILURE:
      return { ...state, contractItemUsagePdfLoading: false };

    case REGENERATE_CONTRACT_ITEM_USAGE_PDF:
      return { ...state, regenerateContractItemUsagePdfLoading: true };
    case REGENERATE_CONTRACT_ITEM_USAGE_PDF_SUCCESS:
      return {
        ...state,
        regenerateContractItemUsagePdfSuccess: action.payload,
        regenerateContractItemUsagePdfLoading: false,
      };
    case REGENERATE_CONTRACT_ITEM_USAGE_PDF_FAILURE:
      return { ...state, regenerateContractItemUsagePdfLoading: false };

    case GET_CONTRACT_ITEM_CREDIT_LIST:
      return { ...state, contractItemCreditListLoading: true };
    case GET_CONTRACT_ITEM_CREDIT_LIST_SUCCESS:
      return {
        ...state,
        contractItemCreditList: action.payload,
        contractItemCreditListLoading: false,
      };
    case GET_CONTRACT_ITEM_CREDIT_LIST_FAILURE:
      return { ...state, contractItemCreditListLoading: false };

    case CREATE_CONTRACT_ITEM_CREDIT:
      return { ...state, createContractItemCreditLoading: true };
    case CREATE_CONTRACT_ITEM_CREDIT_SUCCESS:
      return {
        ...state,
        createContractItemCreditSuccess: action.payload,
        createContractItemCreditLoading: false,
      };
    case CREATE_CONTRACT_ITEM_CREDIT_FAILURE:
      return { ...state, createContractItemCreditLoading: false };

    case UPDATE_CONTRACT_ITEM_CREDIT:
      return { ...state, updateContractItemCreditLoading: true };
    case UPDATE_CONTRACT_ITEM_CREDIT_SUCCESS:
      return {
        ...state,
        updateContractItemCreditSuccess: action.payload,
        updateContractItemCreditLoading: false,
      };
    case UPDATE_CONTRACT_ITEM_CREDIT_FAILURE:
      return { ...state, updateContractItemCreditLoading: false };

    case DELETE_CONTRACT_ITEM_CREDIT:
      return { ...state, deleteContractItemCreditLoading: true };
    case DELETE_CONTRACT_ITEM_CREDIT_SUCCESS:
      return {
        ...state,
        deleteContractItemCreditSuccess: action.payload,
        deleteContractItemCreditLoading: false,
      };
    case DELETE_CONTRACT_ITEM_CREDIT_FAILURE:
      return { ...state, deleteContractItemCreditLoading: false };

    case GET_CONTRACT_ITEM_PORTFOLIO:
      return { ...state, contractItemPortfolioLoading: true };
    case GET_CONTRACT_ITEM_PORTFOLIO_SUCCESS:
      return {
        ...state,
        contractItemPortfolio: action.payload,
        contractItemPortfolioLoading: false,
      };
    case GET_CONTRACT_ITEM_PORTFOLIO_FAILURE:
      return { ...state, contractItemPortfolioLoading: false };

    case GET_CONTRACT_ITEM_DEBIT_LIST:
      return { ...state, contractItemDebitListLoading: true };
    case GET_CONTRACT_ITEM_DEBIT_LIST_SUCCESS:
      return {
        ...state,
        contractItemDebitList: action.payload,
        contractItemDebitListLoading: false,
      };
    case GET_CONTRACT_ITEM_DEBIT_LIST_FAILURE:
      return { ...state, contractItemDebitListLoading: false };

    case GET_JOB_LIST_BY_CONTRACT_ITEM:
      return { ...state, jobListByContractItemLoading: true };
    case GET_JOB_LIST_BY_CONTRACT_ITEM_SUCCESS:
      return {
        ...state,
        jobListByContractItem: action.payload,
        jobListByContractItemLoading: false,
      };
    case GET_JOB_LIST_BY_CONTRACT_ITEM_FAILURE:
      return { ...state, jobListByContractItemLoading: false };

    default:
      return state;
  }
};

export default Contract;
